/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { authorStatisticsModelSchema } from "./authorStatisticsModelSchema.ts";
import { z } from "zod";

export const authorStatisticsModelPagedResultSchema = z.object({
    "totalItems": z.number().int(),
"itemsQuantity": z.number().int(),
"itemsOffset": z.number().int(),
"items": z.array(z.lazy(() => authorStatisticsModelSchema))
    })